import { FC } from "react";
import { useHorizontalScroll, ScrollDirection } from "./fade-horizontal-scroll.hooks";
import {
  StyledHorizontalScrollWrapper,
  StyledHorizontalScrollable,
  StyledLeftFade,
  StyledRightFade,
} from "./fade-horizontal-scroll.styles";
import { MDSFadeHorizontalScrollProps } from "./fade-horizontal-scroll.types";
import { MDSHorizontalScrollButton } from "./horizontal-scroll-button";

export const MDSFadeHorizontalScroll: FC<MDSFadeHorizontalScrollProps> = ({
  children,
  className,
  scrollButtonClassName,
  variant = "standard",
  ...rest
}) => {
  const {
    scrollContainerRef,
    scrollState,
    handleScroll,
    startScrolling,
    stopScrolling,
    scrollForDuration,
  } = useHorizontalScroll();

  return (
    <StyledHorizontalScrollWrapper data-mds-name="fade-horizontal-scroll">
      <MDSHorizontalScrollButton
        direction={ScrollDirection.Left}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
      <StyledLeftFade $visible={scrollState.leftVisible} />
      <StyledHorizontalScrollable
        {...rest}
        className={className}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        {children}
      </StyledHorizontalScrollable>
      <StyledRightFade $visible={scrollState.rightVisible} />
      <MDSHorizontalScrollButton
        direction={ScrollDirection.Right}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
    </StyledHorizontalScrollWrapper>
  );
};
